export const ANALYSIS_TYPES = {
  weight: 'BODY_CONDITION',
  stool: 'STOOL',
  dental: 'DENTAL',
};

export const ANALYSIS_SOURCE = {
  human: 'HUMAN_IN_THE_LOOP',
  dl: 'DL_MODEL',
};

export const ANALYSIS_QUALITY_TYPES = {
  good: 'Healthy',
  neutral: 'Overweight',
  under: 'Underweight',
  bad: 'Vet',
  uncertain: 'Unable',
};

export const ANALYSIS_HEADLINE = {
  seekVeterinaryCare: 'Seek Veterinary Care',
  weightGood: 'Doing Great!',
  overweight: 'Overweight',
  underweight: 'Underweight',
  noBodyFound: 'No Body Found',
  reviewInProgress: 'Expert Review in Progress',
};
